export interface GetMfaContactDisplayArgs {
  /** New phone number being verified (takes precedence over user.phone) */
  newPhone?: string | null;
  /** Current user — pass the object from useJaneUser's `data.user` */
  user?: { email?: string | null; phone?: string | null } | null;
  /** Whether the contact channel is email vs SMS (caller reads config) */
  usesEmail: boolean;
}

/** Builds the masked-phone or email string shown in MFA verification screens. */
export const getMfaContactDisplay = ({
  newPhone,
  usesEmail,
  user,
}: GetMfaContactDisplayArgs): string => {
  if (usesEmail) {
    return user?.email ?? '';
  }

  const phone = newPhone || user?.phone;
  const phoneLastFour = phone?.slice(-4) ?? '';
  return `( ••• ) ••• - ${phoneLastFour}.`;
};
